import { render, staticRenderFns } from "./wf-text-field-display.vue?vue&type=template&id=1a564baf&scoped=true&"
import script from "./wf-text-field-display.vue?vue&type=script&lang=ts&"
export * from "./wf-text-field-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-text-field-display.vue?vue&type=style&index=0&id=1a564baf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a564baf",
  null
  
)

export default component.exports